// extracted by mini-css-extract-plugin
module.exports = {"highlightedContainer":"HighlightedContainer_highlightedContainer__3hmlG","highlightedContainer__innerSpacing":"HighlightedContainer_highlightedContainer__innerSpacing__1kyEc"};